import styled from "styled-components";

export const PaymentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 0 auto;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    gap: 5px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const PaymentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
`;

export const StepIndicator = styled.div`
    flex: 1;
    text-align: center;
    padding: 10px;
    background-color: ${(props) => (props.active ? "#007bff" : "#e0e0e0")};
    color: ${(props) => (props.active ? "white" : "#333")};
    border-radius: 4px;
    font-weight: bold;
    margin: 0 5px;
`;

export const StepContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SelectWrapper = styled.div`
    margin-bottom: 20px;
    width: 100%;

    select {
        border: thin solid blue;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: linear-gradient(45deg, transparent 50%, #0056b3 50%),
            linear-gradient(135deg, #0056b3 50%, transparent 50%), linear-gradient(to right, #9fbad6, #9fbad6);
        background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), 100% 0;
        background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
        background-repeat: no-repeat;
    }

    select:focus {
        background-image: linear-gradient(45deg, white 50%, transparent 50%),
            linear-gradient(135deg, transparent 50%, white 50%), linear-gradient(to right, gray, gray);
        background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, 100% 0;
        background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
        background-repeat: no-repeat;
        border-color: grey;
        outline: 0;
    }
`;

export const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    margin-top: 5px;
    width: 100%;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
        background-color: #0056b3;
    }
`;
